import { useAppServiceList } from 'hooks/use-app-service-list/use-app-service-list';
import { useDatabaseList } from 'hooks/use-database-list/use-database-list';
import { useOrganizationList } from 'hooks/use-organization-list/use-organization-list';
import { useOrganizationManager } from 'hooks/use-organization-manager/use-organization-manager';
import { useProjectList } from 'hooks/use-project-list/use-project-list';
import { POLLING_INTERVAL_IN_MILLISECONDS } from './use-data-loader.constants';

export const useDataLoader = () => {
  const { organizationId } = useOrganizationManager();

  const { areOrganizationRecordsLoading: organizationsLoading } = useOrganizationList({
    refetchInterval: POLLING_INTERVAL_IN_MILLISECONDS,
    fetchTrials: true,
  });
  const {
    query: { isLoading: projectsLoading },
  } = useProjectList({ refetchInterval: POLLING_INTERVAL_IN_MILLISECONDS, organizationId: organizationId || '' });
  const {
    query: { isLoading: appServicesLoading },
  } = useAppServiceList({ refetchInterval: POLLING_INTERVAL_IN_MILLISECONDS, organizationId: organizationId || '' });
  const {
    query: { isLoading: databasesLoading },
  } = useDatabaseList({ refetchInterval: POLLING_INTERVAL_IN_MILLISECONDS, organizationId: organizationId || '' });

  return { organizationsLoading, projectsLoading, appServicesLoading, databasesLoading };
};
